/* eslint no-param-reassign: "off" */
import useLoadingStore from '@stores/loading';
import LoadingComponent from './k-loading.vue';

export default {
  install(app) {
    const loadingStore = useLoadingStore();
    app.component('k-loading-component', LoadingComponent);

    app.config.globalProperties.$Loading = {
      start() {
        loadingStore.loadingStart();
      },
      minimal() {
        loadingStore.loadingMinimal();
      },
      finish() {
        loadingStore.loadingFinish();
      },
    };
  },
};
